import React from "react";

export let FileInput = class extends React.Component {
    constructor(props) {
        super(props)
        this.onChange = this.onChange.bind(this)
    }

    onChange(e) {
        const { input: { onChange }, changeCallback } = this.props
        onChange(e.target.files[0]);
        if (changeCallback)
            changeCallback(e.target.files[0]);
    }

    render() {

        const { label, accept, disabled, meta: { touched, error, warning } } = this.props;
        return (
            <div className='form-group'>
                <label className='control-label col-sm-3'>{label}</label>
                <div className='controls col-sm-9'>
                    <input
                        disabled={disabled}
                        placeholder={label}
                        type='file'
                        accept={accept ? accept : ".png"}
                        style={{ width: '400px', resize: 'vertical' }}
                        className='form-control'
                        onChange={this.onChange} />
                    {touched && ((error && <span style={{ color: "red", marginLeft: "5px" }}>{error}</span>) || (warning &&
                        <span>{warning}</span>))}
                </div>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/common/FileInput.jsx